"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewEntity = NewEntity;
const Form_1 = require("@juvare/common-form-ui/Form");
const AppPage_1 = require("@juvare/common-web-ui/AppPage");
const AppPageHeader2_1 = require("@juvare/common-web-ui/AppPageHeader2");
const NavigationContext_1 = require("@juvare/common-web-ui/NavigationContext");
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const useDefaultFormConfig_1 = require("../../../../../../ui/features/classifiers/hooks/useDefaultFormConfig");
const hooks_1 = require("../../../../../../ui/hooks");
const usePlatformSdkReactTranslation_1 = require("../../../../../../ui/hooks/usePlatformSdkReactTranslation");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
function NewEntity(props) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const navigationContext = react_1.default.useContext(NavigationContext_1.NavigationContext);
    const navigate = (0, react_router_1.useNavigate)();
    const location = (0, react_router_1.useLocation)();
    const storage = (0, hooks_1.useStorageClient)(props.entity);
    const defaultFormConfig = (0, useDefaultFormConfig_1.useDefaultFormConfig)();
    return (react_1.default.createElement(AppPage_1.AppPage, { header: react_1.default.createElement(AppPageHeader2_1.AppPageHeader2, { title: props.title, subTitle: 'New', onBack: () => navigationContext.navigate(() => (location.state?.back ? navigate(-1) : navigate('..'))) }), contentWidth: props.formWidth ?? 800, contentScrollable: true, contentPadding: 2 },
        react_1.default.createElement(Form_1.Form, { config: props.formConfig ?? defaultFormConfig, submitLabel: t('common.save'), trackChanges: 'ask-to-save', onSubmit: (newData) => storage.post({
                action: 'create',
                data: newData,
            }), onSubmitSuccess: (_newData, response) => {
                (0, SnackbarHelper_1.showInfoSnackbar)({ message: t('common.newItemSaved', { item: props.title }) });
                navigate({
                    pathname: '..',
                    search: new URLSearchParams({ id: response.id }).toString(),
                }, {});
            } })));
}
